import { S as Swiper } from './swiper-core-CZxReCTq.js';
import { A as Autoplay } from './autoplay-Budm5jo2.js';

/**
 * Initialize Announcement Bar Swiper functionality
 * Creates a horizontal carousel for USP items with mobile-first approach
 */
class AnnouncementBar {
  constructor() {
    this.init();
  }

  /**
   * Initialize all announcement bar swipers on the page
   */
  init() {
    const announcementBarElements = document.querySelectorAll('.swiper--announcement-bar');

    announcementBarElements.forEach((element) => {
      this.initSwiper(element);
    });
  }

  /**
   * Parse breakpoints from data attribute
   * @param {string} breakpointsStr - JSON string of breakpoints
   * @returns {Object} - Parsed breakpoints object
   */
  parseBreakpoints(breakpointsStr) {
    try {
      return JSON.parse(breakpointsStr);
    } catch (error) {
      console.warn('Failed to parse breakpoints:', error);
      return {};
    }
  }

  /**
   * Initialize Swiper for a specific announcement bar element
   * @param {Element} swiperEl - The swiper container element
   */
  initSwiper(swiperEl) {
    if (!swiperEl) return;

    // Get configuration from data attributes
    const showPagination = swiperEl.dataset.showPagination === 'true';
    const showNavigation = swiperEl.dataset.showNavigation === 'true';
    const loop = swiperEl.dataset.loop === 'true';
    const autoplay = swiperEl.dataset.autoplay === 'true';
    const pauseOnHover = swiperEl.dataset.autoplayPauseOnHover === 'true';
    const slidesPerView = parseFloat(swiperEl.dataset.slidesPerView) || 1;
    const breakpoints = this.parseBreakpoints(swiperEl.dataset.breakpoints || '{}');

    const swiperOptions = {
      modules: [Autoplay],
      spaceBetween: 16,
      slidesPerView,
      watchOverflow: true,
      pagination: showPagination
        ? {
            el: swiperEl.querySelector('.swiper-pagination'),
            clickable: true,
          }
        : false,
      navigation: showNavigation
        ? {
            nextEl: swiperEl.querySelector('.swiper-button-next'),
            prevEl: swiperEl.querySelector('.swiper-button-prev'),
          }
        : false,
      loop,
      autoplay: autoplay
        ? {
            delay: 3000,
            disableOnInteraction: false,
            pauseOnMouseEnter: pauseOnHover,
          }
        : false,
      breakpoints,
    };

    // Initialize Swiper
    new Swiper(swiperEl, swiperOptions);
  }
}

// Initialize when DOM is loaded
document.addEventListener('DOMContentLoaded', () => {
  new AnnouncementBar();
});

// Re-initialize when new content is loaded (for dynamic content)
document.addEventListener('shopify:section:load', () => {
  new AnnouncementBar();
});
